import { Locale } from "./index";

export const getCurrentLanguageFromUrl = (): Locale => {
  const pathname = window.location.pathname;
  const segments = pathname.split("/").filter(Boolean);

  const firstSegment = segments[0];
  if (firstSegment === "en") {
    return "en";
  }
  return "fa";
};

export const redirectToDefaultLanguage = (defaultLanguage: Locale = "fa") => {
  const pathname = window.location.pathname;
  const search = window.location.search;
  const hash = window.location.hash;
  const segments = pathname.split("/").filter(Boolean);

  const firstSegment = segments[0];
  if (firstSegment !== "en" && firstSegment !== "fa" && defaultLanguage !== "fa") {
    const currentPath = pathname === "/" ? "" : pathname;
    const newPath = `/${defaultLanguage}${currentPath}`;
    const fullUrl = newPath + search + hash;
    window.location.replace(fullUrl);
  }
};

export const updateUrlWithLanguage = (newLanguage: Locale) => {
  const currentPath = window.location.pathname;
  const search = window.location.search;
  const hash = window.location.hash;
  const segments = currentPath.split("/").filter(Boolean);

  if (segments[0] === "en" || segments[0] === "fa") {
    segments.shift();
  }

  let newPath: string;
  if (newLanguage === "fa") {
    newPath = segments.length > 0 ? "/" + segments.join("/") : "/";
  } else {
    newPath = `/${newLanguage}${segments.length > 0 ? "/" + segments.join("/") : ""}`;
  }

  // Preserve query parameters and hash
  const fullUrl = newPath + search + hash;
  window.history.pushState({}, "", fullUrl);
};

export const getPathWithoutLanguage = (): string => {
  const pathname = window.location.pathname;
  const segments = pathname.split("/").filter(Boolean);

  if (segments[0] === "en" || segments[0] === "fa") {
    segments.shift();
  }

  return segments.length > 0 ? "/" + segments.join("/") : "/";
};

export const hasLanguageInUrl = (): boolean => {
  const pathname = window.location.pathname;
  const segments = pathname.split("/").filter(Boolean);
  return segments[0] === "en" || segments[0] === "fa";
};

export const createPathWithCurrentLanguage = (path: string): string => {
  const currentLanguage = getCurrentLanguageFromUrl();

  if (currentLanguage === "fa") {
    return path;
  }

  return `/${currentLanguage}${path}`;
};

export const navigateWithLanguage = (path: string) => {
  const pathWithLanguage = createPathWithCurrentLanguage(path);
  const search = window.location.search;
  const hash = window.location.hash;
  const fullUrl = pathWithLanguage + search + hash;
  window.location.href = fullUrl;
};
